
// PRODS
export const url= "https://hot.uruz.id/api/"
export const userServer = "uruz"

// DEV
// export const url = "https://cool.uruz.id/api/"
// export const userServer = "cooluruz"